import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';

class ReferController extends Controller {
  queryParams = [{ campaignId: 'campaign_id' }];

  @service('state-managers/application')
  applicationStateManager;

  @service
  session;

  @service
  router;

  @service
  api;

  @service
  store;

  campaignId = null;

  @action
  handleComplete() {
    this.applicationStateManager.addToast('Thank you! Your referral has been submitted.');
    this.router.transitionTo('dashboard');
  }

  @dropTask
  *loadCampaign(campaignId) {
    const response = yield this.api.get(`campaigns/${campaignId}`);
    this.store.pushPayload(response);
    return this.store.peekRecord('campaign', response.data.id);
  }
}

export default ReferController;
